<template>
  <div class="box" :class="{ 'to-bottom': !isLogin || hasLoadPaytype }">
    <!-- password自动填充问题 弹窗前移 -->
    <!-- 选角弹窗 -->
    <transition name="fade" mode="out-in">
      <select-role-popup v-if="isSelectRolePopup"></select-role-popup>
    </transition>
    <!-- 破冰弹窗组 -->
    <template v-for="popup in showPopupList">
      <welcome-popup :popupInfo="popup"></welcome-popup>
    </template>
    <!-- 登录弹窗 -->
    <transition name="fade" mode="out-in">
      <login-popup v-show="isLoginPopup && isFinishInit"></login-popup>
    </transition>

    <top-header></top-header>
    <pwa-award></pwa-award>
    <top-banner></top-banner>
    <notice></notice>
    <login-info
      v-if="!hasLoadPaytype"
      class="login-info"
      :showSwicthBtn="true"
      :showIcon="isLandscape"
    ></login-info>
    <float-activity></float-activity>
    <div class="content">
      <div class="container product-container" v-show="!hasLoadPaytype">
        <img
          class="content-bg"
          v-if="timeAwardList.length && moduleBg"
          :src="moduleBg"
          alt="moduleBg"
        />
        <limited-time-activity></limited-time-activity>
        <select-product></select-product>
      </div>
      <div class="container order-container" v-if="hasLoadPaytype">
        <select-paytype v-if="showChannel"></select-paytype>
      </div>
    </div>
    <page-footer :class="{ 'order-bg': hasLoadPaytype }"></page-footer>
    <not-login-bottom></not-login-bottom>
    <Tabbar v-if="isLogin && !hasLoadPaytype"></Tabbar>
    <!-- 优惠券 -->
    <transition name="fade">
      <div
        class="popup-shadow"
        style="z-index: 8"
        v-show="isShowPaytypePopupCoupon || isShowGameCouponPopup"
      ></div>
    </transition>
    <transition :name="tranName">
      <coupon-list-popup
        v-if="isShowPaytypePopupCoupon"
        popupType="paytype"
        :enableCouponList="paytypeEnableCouponList"
        :disableCouponList="paytypeDisableCouponList"
        :expireCouponList="paytypeExpireCouponList"
        :languages="letter"
        @closeCouponPopup="hidePaytypeCouponPopup"
      ></coupon-list-popup>
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :languages="letter"
        @closeCouponPopup="hideGameCouponPopup"
      ></coupon-list-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <coupon-vip-popup
        v-if="isShowVipCouponPopup"
        @closeCouponPopup="hideVipCouponPopup"
        :couponList="vipCouponList"
      ></coupon-vip-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <coupon-birth-popup
        v-if="isShowBirthCouponPopup"
        @closeCouponPopup="hideBirthCouponPopup"
        :couponList="birthCouponList"
      ></coupon-birth-popup>
    </transition>
    <!-- 全局提示弹窗 -->
    <PopupWindow
      v-if="globalTipsVisible"
      type="tips"
      :languages="letter"
      :content="globalTipsContent"
      textAlign="center"
      @onConfirm="globalTipsVisible = false"
      @onCancel="globalTipsVisible = false"
    ></PopupWindow>
    <!-- 购物车删除弹窗 -->
    <PopupWindow
      v-if="showDetelePopup"
      :languages="letter"
      :content="letter.check_remove_cart"
      textAlign="center"
      @onConfirm="removeProduct(deleteItem)"
      @onCancel="cancelSubProduct"
    ></PopupWindow>
    <PopupWindow
      type="tips"
      v-if="visibleRightCenterPopup"
      :confirm="letter.go"
      :languages="letter"
      :content="offLineNotice"
      :title="rightCenterNoticeTitle"
      :autoHeight="true"
      textAlign="center"
      @onConfirm="goRightsCenter"
      @onCancel="visibleRightCenterPopup = false"
      class="right-center-popup"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleRightsNotice"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="pnsRightCenterNoticeTitle"
      :content="pnsRightCenterNotice"
      :autoHeight="true"
      :confirm="letter.v3GoTo"
      @onConfirm="confirmRightsNotice"
      @onCancel="closeRightsNotice"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleCloseCouponSend"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="pnsCloseCouponSendTitle"
      :content="pnsCloseCouponSendContent"
      :autoHeight="true"
      :confirm="letter.v3GoTo"
      @onConfirm="confirmRightsNotice"
      @onCancel="closeCouponSend"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleJpGamePayDown"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="jpDownGame.title"
      :content="jpDownGame.content"
      :autoHeight="true"
      @onConfirm="closeJpGamePayDown"
      @onCancel="closeJpGamePayDown"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleJiangMeiExtraCoinDown"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="jpJiangMeiExtraCoinDownTitle"
      :content="jpJiangMeiExtraCoinDownContent"
      :autoHeight="true"
      @onConfirm="closeJiangMeiExtraCoinDown"
      @onCancel="closeJiangMeiExtraCoinDown"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleJiangmeiCouponDown"
      type="tips"
      textAlign="left"
      :languages="letter"
      :title="jpJiangmeiCouponDownTitle"
      :content="jpJiangmeiCouponDownContent"
      :autoHeight="true"
      @onConfirm="closeJiangmeiCouponDown"
      @onCancel="closeJiangmeiCouponDown"
    ></PopupWindow>
    <transition name="fade" mode="out-in">
      <Loading v-show="loading"></Loading>
    </transition>
  </div>
</template>

<script>
import PwaAward from '@components/officialTopup/pwa/PwaAward.vue';
import TopBanner from '@components/officialTopup/TopBanner.vue';
import TopHeader from '@components/officialTopup/TopHeader.vue';
import Notice from '@components/officialTopup/activity/Notice.vue';
import WelcomePopup from '@components/officialTopup/activity/WelcomePopup.vue';
import LimitedTimeActivity from '@components/officialTopup/activity/LimitedTimeActivity.vue';
import SelectProduct from '@components/officialTopup/product/SelectProduct.vue';
import SelectPaytype from '@components/officialTopup/paytype/SelectPaytype.vue';
import CouponVipPopup from '@components/officialTopup/coupon/CouponVipPopup.vue';
import CouponBirthPopup from '@components/officialTopup/coupon/CouponBirthPopup.vue';
import CouponListPopup from '@components/officialTopup/coupon/CouponListPopup.vue';
import FloatActivity from '@components/officialTopup/activity/FloatActivity.vue';
import Loading from '@components/officialTopup/Loading.vue';
import coupon from '@mixins/officialTopup/coupon';
import login from '@mixins/officialTopup/login';
import userStatus from '@mixins/officialTopup/userStatus';
import iconSetting from '@mixins/officialTopup/iconSetting';
import style from '@mixins/officialTopup/style';
import cartAddAndDetail from '@mixins/officialTopup/cartAddAndDetail';
import allStorePopup from '@mixins/allStorePopup';

import LoginPopup from '@components/officialTopup/login/LoginPopup.vue';
import LoginInfo from '@components/officialTopup/login/LoginInfo.vue';
import NotLoginBottom from '@components/officialTopup/login/NotLoginBottom.vue';
import SelectRolePopup from '@components/officialTopup/login/SelectRolePopup.vue';
import PageFooter from '@components/officialTopup/PageFooter.vue';
import { GET_ACTIVITY_LIST } from '@store/officialTopup/activity';
import { SET_GLOBAL_TIPS_VISIBLE } from '@store/officialTopup';

import bridge from '@utiles/officialStore/bridge';

import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import openActivity, { NOTICE_POPUP_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export default {
  name: 'webStorePage',
  mixins: [
    login,
    userStatus,
    coupon,
    iconSetting,
    style,
    cartAddAndDetail,
    allStorePopup
  ],
  data() {
    return {
      isLandscape: window.innerWidth > window.innerHeight,
      visibleRightCenterPopup: false // 权益中心弹窗
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      loading: state => state.loading,
      showChannel: state => state.showChannel,
      hasLoadPaytype: state => state.hasLoadPaytype,
      letter: state => state.letter,
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      loginAccount: state => state.login.loginAccount,
      uid: state => state.login.uid,
      isUidLogin: state => state.login.isUidLogin,
      popupList: state => state.activity.popupList,
      timeAwardList: state => state.activity.timeAwardList,
      globalTipsVisible: state => state.globalTipsVisible,
      globalTipsContent: state => state.globalTipsContent,
      showDetelePopup: state => state.cart.showDetelePopup,
      picList: state => state.page.picList,
      isFinishInit: state => state.page.isFinishInit
    }),
    ...mapGetters(['isJpPlatform', 'gameInfoConfig']),
    moduleBg() {
      return this.picList?.giftlistbg;
    },
    cart() {
      return this.$store.state.cart;
    },
    showPopupList() {
      // 因为权重高的在前面所以倒序显示覆盖前面弹窗
      return this.popupList.filter(item => item?.basic?.isShow).reverse();
    },
    globalTipsVisible: {
      get() {
        return this.$store.state.globalTipsVisible;
      },
      set(val) {
        this.$store.commit(SET_GLOBAL_TIPS_VISIBLE, val);
      }
    },
    showRightCenterPopup() {
      const gameInfoConfig = this.gameInfoConfig;
      if (
        !gameInfoConfig?.offLineTime ||
        !gameInfoConfig?.isShowPreRightsPopup
      ) {
        return false;
      }
      const announcementEndTime = new Date(gameInfoConfig.offLineTime);
      const currentTime = new Date();
      const currentTimeZoneOffset = currentTime.getTimezoneOffset();
      const currentUTCTime = new Date(
        currentTime.getTime() - currentTimeZoneOffset * 60000
      );
      if (currentUTCTime > announcementEndTime) {
        return false;
      }
      // 2025.05.27 PNS支付页优惠劵下架公告特殊处理
      const announcementStartTime = new Date('2025-05-28T00:00:00+00:00');
      if (+this.gameId === 191 && currentUTCTime < announcementStartTime) {
        return false;
      }
      return true;
    },
    showRightsCenter() {
      const gameInfoConfig = this.gameInfoConfig;
      if (
        !gameInfoConfig?.isOnlineRightsCenter ||
        !gameInfoConfig?.onlineRightsCenterTime
      ) {
        return false;
      }
      const startTime = new Date(gameInfoConfig.onlineRightsCenterTime);
      const currentTime = new Date();
      const currentTimeZoneOffset = currentTime.getTimezoneOffset();
      const currentUTCTime = new Date(
        currentTime.getTime() - currentTimeZoneOffset * 60000
      );
      if (currentUTCTime < startTime) {
        return false;
      }
      return true;
    },
    rightCenterNoticeTitle() {
      // 2025.05.27 PNS支付页优惠劵下架公告特殊处理
      if (+this.gameId === 191) {
        return this.letter.rightCenterNoticeTitle;
      }
      return this.letter.notice;
    },
    offLineNotice() {
      // 2025.05.27 PNS支付页优惠劵下架公告特殊处理
      if (+this.gameId === 191) {
        return this.letter.rightCenterNoticeContent;
      }
      return (
        this.letter.preRightsIntro.replace(
          '${offLineDate}',
          this.gameInfoConfig?.offLineDate[this.lang] ||
            this.gameInfoConfig?.offLineDate['en-US'] ||
            ''
        ) || ''
      );
    }
  },
  watch: {
    showChannel(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          document
            .getElementById('pay-container')
            ?.scrollIntoView({ behavior: 'smooth' });
        });
      }
    },
    isLogin: {
      handler(newVal) {
        if (newVal) {
          this.getActivityList();
          this.selectRole();
          this.loadVipCouponInfo();
          this.checkShowRightCenterPopup();
        }
      }
    },
    hasLoadPaytype: {
      handler(newVal) {
        if (newVal) {
          // 提单页面
        }
      }
    },
    // 活动是根据语言参数接口由接口处理多语言，所以语言变化时需要重新获取活动列表
    lang: {
      handler(newVal) {
        if (!newVal) return;
        this.$store.dispatch(GET_ACTIVITY_LIST, {
          pos: ['index_banner', 'lamp', 'time_award']
        });
      }
    }
  },
  created() {
    // 2025-04-10 修复日本平台游戏内拉起第三方支付时，gmo渠道无法正常储值，改为外跳浏览器
    if (this.isJpPlatform) {
      if (bridge.runInsdk() && window.location.pathname == '/mobile/paytype') {
        bridge.callSdkMethod('openBrowser', {
          url: window.location.href,
          loginDir: 1,
          appendParams: 1
        });
      }
    }
  },
  methods: {
    goRightsCenter() {
      let jumpLink = '';
      if (this.gameInfoConfig?.isOnlineRightsCenter && this.showRightsCenter) {
        jumpLink = this.gameInfoConfig?.preRightsPopupLink
          ? this.gameInfoConfig?.preRightsPopupLink
          : this.gameInfoConfig?.rightsCenterLink;
        openActivity(NOTICE_POPUP_ACTIVITY, jumpLink, {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        });
      } else {
        jumpLink = `${window.location.href.replace(
          'officialTopup.html',
          'officialStore.html'
        )}vip_score`;
        sdkOpenLink({
          link: jumpLink
        });
      }
      this.visibleRightCenterPopup = false;
    },
    checkShowRightCenterPopup() {
      if (!this.showRightCenterPopup) {
        return;
      }
      let RIGHT_CENTER_POPUP_STATE = 'RIGHT_CENTER_POPUP_STATE' + this.gameId;
      if (!+globalConfig.getCookie(RIGHT_CENTER_POPUP_STATE)) {
        this.visibleRightCenterPopup = true;
        // 3s后设置cookie, 避免刷新误触发
        setTimeout(() => {
          globalConfig.setCookie(RIGHT_CENTER_POPUP_STATE, 1);
        }, 3000);
      }
    }
  },
  components: {
    PwaAward,
    TopBanner,
    TopHeader,
    Notice,
    LimitedTimeActivity,
    SelectProduct,
    CouponVipPopup,
    CouponBirthPopup,
    CouponListPopup,
    SelectPaytype,
    Loading,
    LoginPopup,
    LoginInfo,
    SelectRolePopup,
    PageFooter,
    WelcomePopup,
    NotLoginBottom,
    FloatActivity
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
.box {
  position: relative;
  background-color: $backgroundColor;
  padding-bottom: $tabbarHeight;
  width: 100%;
  height: auto;
  // min-height: 100%;
  overflow: visible;
  &.to-bottom {
    padding-bottom: 0;
  }
}

.content {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px auto 0;
  min-height: 480px;

  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 0;
  }
}

.account-info {
  border-radius: 20px;
}

.container {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 0 40px;
}
.product-container {
  background-color: $moduleBackgroundColor;
}

.order-container {
  background-color: $backgroundColor;
  margin-bottom: 100px;
}

.content-box {
  position: relative;
  font-size: 0;
}
.order-bg {
  background-color: $backgroundColor;
}

.right-center-popup {
  z-index: 1001;
  ::v-deep .tips-content {
    max-height: 60vh;
    overflow-y: auto;
    text-align: left;
  }
  ::v-deep .dialog-title {
    line-height: 32px;
    padding: 10px 80px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media screen and (orientation: landscape) {
  .box {
    padding-bottom: 0;
  }
  .content {
    max-width: 1200px;
    padding-bottom: 20px;
    margin: 21px auto 40px;

    &-bg {
      border-radius: 20px;
    }
  }
  .container {
    border-radius: 20px;
  }
  .order-bg {
    background-color: #111111;
  }
}

/* iPad横向方向样式 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .box {
    overflow: visible;
    padding-bottom: 0;
  }
  .content {
    widows: 1200px;
  }
}
</style>
